import { Route, Routes, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import Home from "./Pages/Home/Home";
import ContactUs from "./Pages/Contact/ContactUs";
import GeneralFAQ from "./Pages/FAQ/GeneralFAQ";
import OnboardingFAQ from "./Pages/FAQ/OnboardingFAQ";
import DataSafety from "./Pages/DataSafety/DataSafety";
import Help from "./Pages/Help/Help";
import Onboarding from "./Pages/Onboarding/Onboarding";
import Livenesscheck from "./Pages/Onboarding/Livenesscheck";
import Finish from "./Pages/Onboarding/Finish";
import Error from "./Pages/Error";
import ComplaintPolicy from "./Pages/ComplaintPolicy/ComplaintPolicy";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import TermsandConditions from "./Pages/TermsandConditions/TermsandConditions";
import MoneyTransfer from "./Pages/MoneyTransfer/MoneyTransfer";
import AboutUs from "./Pages/AboutUs/AboutUs";
import OfferPage from "./Pages/OfferPage";
import Winner from "./Pages/Winner";
import DownloadIfepayApp from "./Pages/DownloadIApp/DownloadIfepayApp";

function App() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="App">

      <Routes>
        <Route path="/*" element={<Error />} />
        <Route path="/" element={<OfferPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/help" element={<Help />} />
        <Route path="/general-faq" element={<GeneralFAQ />} />
        <Route path="/onboarding-faq" element={<OnboardingFAQ />} />
        <Route path="/data-safety" element={<DataSafety />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/finish" element={<Finish />} />
        <Route path="/livenesscheck" element={<Livenesscheck />} />
        <Route path="/terms-and-conditions" element={<TermsandConditions />} />
        <Route path="/complaints-policy" element={<ComplaintPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/money-transfer" element={<MoneyTransfer />} />
        <Route path="/offer" element={<OfferPage />} />
        <Route path="/winners" element={<Winner />} />
        <Route path="/download-ifepay-app" element={<DownloadIfepayApp />} />
      </Routes>

    </div>
  );
}

export default App;
